<template>
  <div class="select-wrap">
<!--    <a-tree-->
<!--      key="depart"-->
<!--      class="pop-tree user-list"-->
<!--      :tree-data="departUserList"-->
<!--      :replace-fields="replaceFields"-->
<!--      v-model:expandedKeys="departExpandedKeys"-->

<!--    >-->
<!--      <template #title="slot">-->
<!--        <div class="user-item tree-user-item cursor"-->
<!--             @click.stop.prevent="expandTreeNode(slot,'depart')">-->
<!--          <div class="user-data">-->
<!--            <img v-if="slot.type==='user'" class="user-avatar"-->
<!--                 :src="slot.avatar?slot.avatar:headerImg" alt="">-->
<!--            <span class="user-name tree-user-name global-ellipsis"-->
<!--                  :title="slot.name">{{ slot.name }}</span>-->
<!--            <PlusOutlined v-if="slot.type!=='user'" @click.stop.prevent="selectNode(slot)" />-->
<!--          </div>-->

<!--          <CheckOutlined class="user-selected"-->
<!--                         v-show="slot.type==='user'&&selectedList?.includes(slot.id)"/>-->
<!--        </div>-->
<!--      </template>-->
<!--    </a-tree>-->

    <a-select ref="userSelectRef"
              class="user-select-box"
              placeholder="请选择人员"
              dropdownClassName="select-category-box"
              mode="multiple"
              showArrow
              showSearch
              allowClear
              :options="allUsers"
              :filterOption="filterUser"
              v-model:value="selectedList"
              @search="search"
              :disabled="disabled"
              @blur="clearKeywords"
              @change="clearKeywords"
              @select="optionSelect"
    >
      <template #dropdownRender="{ menuNode: menu }">
        <v-nodes :vnodes="menu" v-if="keywords"/>
        <div v-if="!keywords">
          <div
            v-show="props.filterMode.indexOf('user') > -1"
            class="select-item"
            :class="{'select-item-active':currentItem==='user'}"
            @mouseover="currentItem='user'"
            @mouseout="currentItem=''"
            @mousedown="(e) => e.preventDefault()"
            @click.stop.prevent="()=>{}"
          >
            <a-popover title=""
                       overlayClassName="pop-card user-select-component"
                       placement="rightTop"
                       trigger="hover"
                       :arrowPointAtCenter="true">
              <template #content>
                <div class="pop-list">
                  <div class="user-list">
                    <div class="user-item cursor" v-for="item in allUsers" :key="item.id"
                         @click="selectItem(item)">
                      <div class="user-data">
                        <img class="user-avatar" :src="item.avatar?item.avatar:headerImg" alt="">
                        <span class="user-name global-ellipsis"
                              :title="item.name">{{ item.name }}</span>
                      </div>

                      <CheckOutlined class="user-selected" v-show="selectedList?.includes(item.id)"/>
                    </div>
                  </div>
                  <div class="no-data" v-if="allUsers.length===0">
                    <a-empty :image="simpleImage"/>
                  </div>
                </div>

              </template>
              <div class="item-label">
              <span>
                <TeamOutlined/>
                成员
              </span>
                <RightOutlined class="item-icon"/>
              </div>
            </a-popover>
          </div>
          <div
            v-show="props.filterMode.indexOf('department') > -1"
            class="select-item"
            :class="{'select-item-active':currentItem==='depart'}"
            @mouseover="currentItem='depart'"
            @mouseout="currentItem=''"
            @mousedown="(e) => e.preventDefault()"
            @click.stop.prevent="()=>{}"
          >
            <a-popover title=""
                       overlayClassName="pop-card user-select-component"
                       placement="rightTop"
                       trigger="hover"
                       :arrowPointAtCenter="true">
              <template #content>
                <div class="pop-list pop-tree-wrap" >
                  <a-tree
                    v-if="departUserList.length>0"
                    key="depart"
                    class="pop-tree user-list"
                    :tree-data="departUserList"
                    :replace-fields="replaceFields"
                    v-model:expandedKeys="departExpandedKeys"
                  >
                    <template #title="slot">
                      <div class="user-item tree-user-item cursor"
                           @click.stop.prevent="expandTreeNode(slot,'depart')">
                        <div class="user-data">
                          <img v-if="slot.type==='user'" class="user-avatar"
                               :src="slot.avatar?slot.avatar:headerImg" alt="">
                          <span class="user-name tree-user-name global-ellipsis"
                                :title="slot.name">{{ slot.name }}</span>
                          <PlusOutlined v-if="slot.type!=='user'&&selectMode==='multiple'" @click.stop.prevent="selectNode(slot)" />
                        </div>

                        <CheckOutlined class="user-selected"
                                       v-show="slot.type==='user'&&selectedList?.includes(slot.id)"/>
                      </div>
                    </template>
                  </a-tree>
                  <div class="no-data" v-else>
                    <a-empty :image="simpleImage"/>
                  </div>
                </div>

              </template>
              <div class="item-label">
              <span>
                <ApartmentOutlined/>
                部门
              </span>
                <RightOutlined class="item-icon"/>
              </div>
            </a-popover>
          </div>
          <div
            v-show="props.filterMode.indexOf('role') > -1"
            class="select-item"
            :class="{'select-item-active':currentItem==='role'}"
            @mouseover="currentItem='role'"
            @mouseout="currentItem=''"
            @mousedown="(e) => e.preventDefault()"
            @click.stop.prevent="()=>{}"
          >
            <a-popover title="" overlayClassName="pop-card user-select-component"
                       :arrowPointAtCenter="true"
                       placement="rightTop"
                       trigger="hover">
              <template #content>
                <div class="pop-list pop-tree-wrap">
                  <a-tree
                    v-if="roleUserList.length>0"
                    key="role-tree"
                    class="pop-tree user-list"
                    :tree-data="roleUserList"
                    :replace-fields="replaceFields"
                    v-model:expandedKeys="roleExpandedKeys"
                  >
                    <template #title="slot">
                      <div class="user-item tree-user-item cursor"
                           @click.stop.prevent="expandTreeNode(slot,'role')">
                        <div class="user-data">
                          <img v-if="slot.type==='user'" class="user-avatar"
                               :src="slot.avatar?slot.avatar:headerImg" alt="">
                          <span class="user-name tree-user-name global-ellipsis"
                                :title="slot.name">{{ slot.name }}</span>
                          <PlusOutlined v-if="slot.type!=='user'&&selectMode==='multiple'" @click.stop.prevent="selectNode(slot)" />
                        </div>

                        <CheckOutlined class="user-selected"
                                       v-show="slot.type==='user'&&selectedList?.includes(slot.id)"/>
                      </div>
                    </template>
                  </a-tree>
                  <div class="no-data" v-else>
                    <a-empty :image="simpleImage"/>
                  </div>
                </div>
              </template>
              <div class="item-label">
              <span>
                <SolutionOutlined/>
                角色
              </span>
                <RightOutlined class="item-icon"/>
              </div>
            </a-popover>
          </div>
        </div>

        <!--        <div class="search-result" @mousedown="(e) => e.preventDefault()">-->
        <!--          <div class="user-list">-->
        <!--            <div class="user-item" v-for="item in filterUsers" :key="item.id" @click="selectSearchUser(item)">-->
        <!--              <img class="user-avatar" :src="headerImg" alt="">-->
        <!--              <span class="user-name global-ellipsis" :title="item.label">{{item.label}}</span>-->
        <!--              <CheckOutlined class="user-selected" v-if="value?.includes(item.id)" />-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="no-data" v-if="allUsers.length===0" >-->
        <!--            <a-empty :image="simpleImage" />-->
        <!--          </div>-->
        <!--        </div>-->
      </template>
    </a-select>

  </div>

</template>
<script lang="ts">
import {defineComponent} from 'vue';
export default defineComponent({
  components: {
    VNodes: (_, {attrs}) => {
      return attrs.vnodes;
    },
  },
});
</script>
<script lang="ts" setup name="ecn-user-select">
import {reactive, ref, unref, onMounted, watch, nextTick, computed} from "vue";
import headerImg from '/@/assets/images/header.png';
import {Empty} from 'ant-design-vue';
import {
  TeamOutlined,
  ApartmentOutlined,
  SolutionOutlined,
  RightOutlined,
  CheckOutlined,
  PlusOutlined,
} from '@ant-design/icons-vue';
import {getUserListApi, getUserListByDepartmentApi, getUserListByRoleApi} from "/@/api/sys/user";
import {cloneDeep} from 'lodash-es';
import { isArray } from '/@/utils/is';

const props = defineProps({
  maxTagCount: {
    type: Number,
    required: false,
    default: 3,
  },
  maxTagTextLength: {
    type: Number,
    required: false,
    default: 3,
  },
  value: {
    type: [Array,String],
    required: true,
  },
  selectMode:{
    type: String,
    required: false,
    default:'multiple',
  },
  disabled: {
    type: Boolean,
    required: false,
  },
  needLabel: {
    type: Boolean,
    required: false,
  },
  filterMode: {
    type: Array,
    required: false,
    default: ['user', 'role', 'department']
  }
})
const emit = defineEmits(['update:value','change']);
// 无数据时展示的缩略图
const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
const userSelectRef = ref();
 // 选中的数据
const selectedList = ref([]);
// 下拉面板当前鼠标所在模块
const currentItem = ref(0);
// 搜索时输入的值
const keywords = ref('');
// 树形组件替换的属性值
const replaceFields = {
  title: 'name',
  key: 'id',
};
// 清除关键词
const clearKeywords = () => {
  keywords.value = '';
}
// 下拉所有用户
const allUsers = ref([]);

// 输入框变化记录输入的值
const search = (value) => {
  keywords.value = value;
}
// 搜索
const filterUser = (inputValue, option) => {
  // console.log(option);
  return option.name?.includes(inputValue) || option.phone?.includes(inputValue);
}
const optionSelect = (value, option)=>{
  // console.log(value, option)
  if(props.selectMode!=='multiple'){
    selectedList.value = [value]
  }
}
// 成员选择人员
const selectItem = (user) => {
  let arr = cloneDeep(selectedList.value);
  // 已选择的要移除
  if (arr.find(id => id === user.id)) {
    arr = arr.filter(id => id !== user.id)
  } else {
    if(props.selectMode==='multiple'){
      arr.push(user.id);
    }else {
      arr = [user.id];
    }
  }
  selectedList.value = arr;
}
// 部门树展开的节点
const departExpandedKeys = ref([]);
// 角色树展开的节点
const roleExpandedKeys = ref([]);
const allOptions = []; // 所有数据平级展开

// 非用户展开树，用户直接选中或取消选中
const expandTreeNode = (node,treeType)=>{
  let expandedKeys = treeType==='depart'?departExpandedKeys:roleExpandedKeys;
  let tempExpandedKeys = cloneDeep(expandedKeys.value)
  /*处理点击文字展开收起*/
  if(node.children.length){
    if(tempExpandedKeys.includes(node.id)){
      tempExpandedKeys= tempExpandedKeys.filter(id=>id!==node.id);
    }else{
      tempExpandedKeys.push(node.id)
    }
    expandedKeys.value = tempExpandedKeys;
  }
  // console.log(expandedKeys.value);
  if(node.type === 'user'){
    selectNode(node)
  }
}

// 点击树节点
const selectNode = (node) => {
  let selectedArr = cloneDeep(selectedList.value);
  if (node.type !== 'user') {
    // 按树形层级获取有人员
    let childrenUser = getChildrenUsers(node);
    // 去重
    childrenUser = Array.from(new Set(childrenUser));
    if (childrenUser.every(id => selectedArr.includes(id))) {
      // 如果已经全选则清空
      // selectedArr = selectedArr.filter(id => !childrenUser.includes(id));
    } else {
     let toAddUser = childrenUser.filter(id=>!selectedArr.includes(id));
      selectedArr = selectedArr.concat(toAddUser);
    }
  } else {
    if (selectedArr.find(id => id === node.id)) {
      selectedArr = selectedArr.filter(id => id !== node.id)
    } else {
      if(props.selectMode==='multiple'){
        selectedArr.push(node.id);
      }else{
        selectedArr= [node.id];
      }

    }
  }
  selectedList.value = selectedArr;
  // console.log(selectedList.value)

}
// 角色树数据
const roleUserList = ref([]);
// 部门树数据
const departUserList = ref([]);
// 递归修改子级的值
const recursionTree = (list) => {
  return list?.map(item => {
    // item.disableCheckbox = item.type !== 'user';
    // item.selectable = item.type !== 'user';
    // 禁用树形自身的选中状态
    item.selectable = false;
    if (props.needLabel) {
      allOptions.push({value: item[replaceFields.key], label: item[replaceFields.title]})
    }
    if (item.children?.length) {
      item.children = recursionTree(item.children)
    }
    return item;
  })
}

// 递归获取某个节点下的所有人员
const getChildrenUsers = (parentNode) => {
  let arr = [];
  if (parentNode.type === 'user') {
    arr.push(parentNode.id);
  }
  if (parentNode.children.length) {
    // 获取该节点所有非用户id
    let childrenDepartList = parentNode.children.filter(child =>child.type !== 'user');
    // 获取该节点所有用户id
    let childrenUserIdList = parentNode.children.filter(child =>child.type === 'user').map(item=>item.id);
    // 先把人加入，防止第一级的人员顺序错误
    arr = arr.concat(childrenUserIdList);
    childrenDepartList.forEach(item => {
      let result = getChildrenUsers(item)
      arr = arr.concat(result);
    })
  }
  return arr;
};
const initData = () => {
  getUserListApi().then(res => {
    allUsers.value = res?.map(item => {
      if (props.needLabel) {
        allOptions.push({value: item.id, label: item.name})
      }
      return {...item, value: item.id, label: item.name};
    })
  })
  getUserListByDepartmentApi().then(res => {
    departUserList.value = recursionTree(res || []);
    if(res?.length){
      departExpandedKeys.value=[res[0].id];
    }
  })
  getUserListByRoleApi().then(res=>{
    roleUserList.value = recursionTree(res||[]);
    if(res?.length){
      roleExpandedKeys.value=[res[0].id];
    }
  })

}

const adhereLabels = (ids) => {
  return ids.map(id => {
    const currentOption = allOptions.find(optionItem => optionItem.value === id);

    return {
      value: id,
      label: currentOption.label,
    }
  })
}

const stripLabels = (values) => {
  return values?.map?.(item => item.value) || []
}
onMounted(() => {
  initData();
})
watch(() => props.value, (val, oldV) => {
    if (props.needLabel) {
      // 防止重复监听，陷入死循环
      if (JSON.stringify(val) === JSON.stringify(oldV)) {
        return;
      }
      selectedList.value = stripLabels(val);
      return;
    }
    // console.log(val)
    if(isArray(val)) {
      selectedList.value = val
    }else{
      selectedList.value = val?val.split(","):[];
    }
    // console.log(selectedList.value)
  },
  {immediate: true})
watch(() =>selectedList.value, (val, oldV) => {
    // console.log(val)
    if (props.needLabel) {
      const result = adhereLabels(selectedList.value);
      emit('update:value', result)
      emit('change', result)
      return;
    }
    emit('update:value', isArray(props.value)?selectedList.value:selectedList.value.join(','))
    emit('change', isArray(props.value)?selectedList.value:selectedList.value.join(','))
  })
</script>

<style lang="less" scoped>
.select-wrap {
  width: 100%;
  //width: 400px;
  min-width: 200px;
  max-width: 100%;
  .user-select-box{
    width: 100%;
  }
}
:deep(.user-select-box .ant-select-selector){
  max-height: 220px;
  overflow-y: auto;
}
:deep(.select-category-box) {
  overflow: visible !important;
}

.select-item {
  width: 100%;
  box-sizing: border-box;
  overflow: visible;
  height: 40px;
  display: flex;

  .item-label {
    padding: 0 14px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #000000;
    font-size: 14px;

    .item-icon {
      color: #CCCCCC;
    }
  }
}

.select-item-active {
  background: #E2EDFF;

  .item-label {
    color: #2C68FF;

    .item-icon {
      color: #2C68FF;
    }
  }
}

.pop-list {
  width: 280px;
  max-height: 350px;
  overflow: auto;

  .pop-item-selected {
    color: #2C68FF;
  }

  .pop-tree {
    width: 100%;
    padding: 0 14px;
  }
}

.pop-tree-wrap {
  height: 350px;
  //max-height: 350px;
}

.search-result {
  width: 100%;

}

:deep(.ant-popover-inner-content) {
  padding: 0;
  z-index: 1000;
}

.user-list {
  .user-item {
    box-sizing: border-box;
    height: 40px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .user-data {
      display: inline-flex;
      align-items: center;
    }

    .user-avatar {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      margin-right: 8px;
    }

    .user-name {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      display: inline-block;
      max-width: 130px;
    }

    .user-selected {
      color: #4983FF;
      margin-left: 8px;
    }
  }

  .tree-user-item {
    padding: 0 14px 0 0;

    .user-name {
      width: 120px;
    }
  }
}

.cursor {
  cursor: pointer;
}

:deep(.pop-tree li .ant-tree-node-content-wrapper:hover) {
  background-color: #E2EDFF !important;
  color: #2C68FF !important;
  user-select: none;
}

:deep(.pop-tree li span.ant-tree-switcher) {
  height: 40px !important;
  line-height: 40px !important;
}

:deep(.pop-tree li .ant-tree-node-content-wrapper) {
  height: 40px !important;
  line-height: 40px !important;
}
</style>

